__turbopack_context__.v({
  "allowOverflow": "bJ8aRa_allowOverflow",
});
